import { likeAudioUrl, withQuery } from '@core/api'
import { httpClient } from '@core/http-client'

export const likeAudio = (id: string, signal?: AbortSignal) => {
    return httpClient.post(withQuery(likeAudioUrl(), { id }), { signal }).json()
}
